<script>
	import { slide } from "svelte/transition";

	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../tealium";
	import { projectSettings, dropZoneOptions } from "../../config";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import Employment from "./components/Employment.svelte";

	// props
	export let persistUrl = null;
	export let pageName = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;

	const options = dropZoneOptions($model.registrationToken);

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="claim-for-yourself-details" on:submit={handleSubmit}>
		<FormRowColumn rowClass="justify-content-center confirmation-hide">
			<h4 class="text-center">
				{@html projectSettings.classActionName}
			</h4>
			<h1 class="text-center">Part 3: Claim For Yourself</h1>
		</FormRowColumn>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<p>
				Only complete this section if you are registering a <b>Claim For Yourself.</b>
			</p>

			<FormRowColumn>
				<YesNoGroup
					{disabled}
					name="workedInNTBetweenDates"
					label="Did you work in the Northern Territory between 1 June 1933 and 12 November 1971?"
					bind:value={$model.claimDetails.workedInNTBetweenDates}
				/>
			</FormRowColumn>

			<p class="bold">
				Please tell us information about your work in the Northern Territory in the table below. You can talk
				about the work you did at more than one place.
			</p>

			<Employment {disabled} bind:employment={$model.claimDetails.employment} />

			<p>
				If you need more space to tell us about your work, please use Additional Information text box at the end
				of this form.
			</p>

			<FormRowColumn>
				<YesNoGroup
					{disabled}
					name="littleOrNoWages"
					label="Did you receive little or no wages for your work (above)?"
					bind:value={$model.claimDetails.littleOrNoWages}
				/>
			</FormRowColumn>

			<FormRowColumn>
				<YesNoGroup
					{disabled}
					name="haveWorkRecords"
					label="Do you have any documents about your work?"
					bind:value={$model.claimDetails.haveWorkRecords}
				/>
			</FormRowColumn>

			{#if $model.claimDetails.haveWorkRecords == "Yes"}
				<div transition:slide|local>
					<p>
						Please upload copies of these documents or text message, email or post (do not post the
						originals) them to us. You do not have to give us documents, but any documents you have may help
						with your registration and payment of compensation money to you.
					</p>

					<FormRowColumn>
						<DropZone
							{disabled}
							{options}
							id="dz_work_records"
							filenamePrefix="SELF_WORK_"
							bind:documentList={$model.workRecordsDocumentList}
						></DropZone>
					</FormRowColumn>
				</div>
			{/if}
		</div>

		<FormRowColumn rowClass="confirmation-hide">
			<NavigationButtons bind:buttons />
		</FormRowColumn>
	</Form>
</PageSection>
